// import React, { useContext, useEffect, useState } from "react";
// import { Link, useLocation } from "react-router-dom";
// import { GlobalContext } from "../Context/GlobalState";
// import { BASE_URL_API_TRANXT_UAT_API } from "../utils/Constant";
// import {
//   FaCalendarAlt,
//   FaChartBar,
//   FaChartPie,
//   FaClipboardList,
//   FaClock,
//   FaFileAlt,
//   FaMapMarkerAlt,
//   FaMoneyBill,
//   FaPlusCircle,
//   FaReceipt,
//   FaRegFilePdf,
//   FaTasks,
//   FaUserSlash,
//   FaUsers,
// } from "react-icons/fa";
// import {
//   MdPeople,
//   MdCheckCircle,
//   MdLockOpen,
//   MdAttachMoney,
//   MdInventory,
//   MdDashboardCustomize,
//   MdPerson,
//   MdAccountBalanceWallet,
// } from "react-icons/md";
// import { IoMdSettings } from "react-icons/io";
// import { FcSalesPerformance } from "react-icons/fc";
// import { GiMoneyStack } from "react-icons/gi";
// const iconMap = {
//   "Admin Dashboard": <FaChartPie style={{ color: "Plum" }} />,
//   "Employee Management": (
//     <MdPeople
//       style={{
//         color: "#FFC300",
//       }}
//     />
//   ),
//   "Salary Management": <FaChartPie style={{ color: "Plum" }} />,
//   Perfomance: <FcSalesPerformance style={{ color: "#FEB941" }} />,
//   "Attendance Management": (
//     <FaClock
//       style={{
//         color: "Turquoise",
//       }}
//     />
//   ),
//   Projects: <FaPlusCircle style={{ color: "yellow" }} />,
//   "Vendor Management": <MdInventory style={{ color: "#41B06E" }} />,
//   "Budget Analysis": <MdDashboardCustomize style={{ color: "#8B5DFF" }} />,
//   "Expense Management": <FaMoneyBill style={{ color: "Plum" }} />,
//   "Payroll Management": (
//     <MdAttachMoney
//       style={{
//         color: "yellow",
//       }}
//     />
//   ),
//   "Expense Payroll": (
//     <FaPlusCircle
//       style={{
//         color: "orange",
//       }}
//     />
//   ),
//   Arrear: <GiMoneyStack style={{ color: "green" }} />,
//   "Account Ledger": <MdAttachMoney style={{ color: "yellow" }} />,
//   "Office Inventory": <MdInventory style={{ color: "#41B06E" }} />,
//   "Leave Approval": <MdCheckCircle style={{ color: "pink" }} />,
//   "Balance Leave": <FaClipboardList style={{ color: "#41B06E" }} />,
//   "Add Leave/WFH": <MdCheckCircle style={{ color: "#DAF7A6" }} />,
//   Access: <MdLockOpen style={{ color: "yellow" }} />,
//   "Create Workspace": <FaPlusCircle style={{ color: "green" }} />,
//   "Task Overview": <FaTasks style={{ color: "pink" }} />,
//   Policy: <FaRegFilePdf style={{ color: "red" }} />,
//   "Inactive Employee": <FaUserSlash style={{ color: "#96C9F4" }} />,
//   Settings: <IoMdSettings style={{ color: "yellow" }} />,
//   Reports: <FaChartBar style={{ color: "#41B06E" }} />,
//   Users: <FaUsers style={{ color: "#41B06E" }} />,
//   "Employee Dashboard": <FaChartPie style={{ color: "Plum" }} />,
//   "Attendance Management":  <FaCalendarAlt
//   style={{
//     color: "yellow", }} />,
//   Profile: <MdPerson
//   style={{ color: "Aqua", }} />,
//   "Expense Tracking": <FaMapMarkerAlt
//   style={{ color: "green", }} />,
//   "Salary Slip":    <FaReceipt
//   style={{ color: "#FEB941" }} />,
//   "Create Work Space":      <FaPlusCircle
//   style={{
//     color: "orange", }} />,
//   "Work Dashboard":       <FaChartPie
//   style={{ color: "Plum", }} />,
//   EPF: <MdAccountBalanceWallet style={{ color: "pink" }} />,
//   EPF: <MdAccountBalanceWallet style={{ color: "pink" }} />,
// };
// const roleNameMap = {
//   "Employee Management": "Employee Management",
//   "Attendance Management": "Attendance Management",
//   "Leave Management": "Approve/Reject Leave",
//   "Expense Management": "View Expense",
//   "Payroll Management": "View Payroll",
//   "Expense Payroll": "View Expense Payroll",
//   "Account Ledger": "View Ledger",
//   "Projects": "View Projects",
//   "Policy Management": "View Policy",
//   "Salary Management": "View Salary Management",
// };

// const Sidebar = () => {
//   const { pathname } = useLocation();
//   const [isLoading, setIsLoading] = useState(false);
//   const { user, setAccessData, setAccessemployeData,accessData ,accessDataemp} =
//     useContext(GlobalContext);
//     console.log(accessDataemp);
//   const userType =
//     user?.us_type || JSON.parse(sessionStorage.getItem("user"))?.us_type || "G";

//   const roleLinks = {
//     A: [
//       { to: "/admin/AdminDashboard", name: "Admin Dashboard" },
//       { to: "/admin/employee-management", name: "Employee Management" },
//       { to: "/admin/salary-management", name: "Salary Management" },
//       { to: "/admin/performance", name: "Perfomance" },
//       { to: "/admin/attendance-management", name: "Attendance Management" },
//       { to: "/admin/Createproject", name: "Projects" },
//       // { to: "/admin/vendor-management", name: "Vendor Management" },
//       // { to: "/admin/budget-analysis", name: "Budget Analysis" },
//       { to: "/admin/expense-management", name: "Expense Management" },
//       { to: "/admin/payroll-management", name: "Payroll Management" },
//       { to: "/admin/expense-payroll", name: "Expense Payroll" },
//       { to: "/admin/arrear", name: "Arrear" },
//       { to: "/admin/account-ledger", name: "Account Ledger" },
//       { to: "/admin/office-inventory", name: "Office Inventory" },
//       { to: "/admin/LeaveApprovalAdmin", name: "Leave Approval" },
//       { to: "/admin/Balance-leave", name: " Balance Leave " },
//       { to: "/admin/add-leave-wfh", name: "Add Leave/WFH" },
//       { to: "/admin/access", name: "Access" },
//       { to: "/admin/create-workspace", name: "Create Workspace" },
//       { to: "/admin/task-overview", name: "Task Overview" },
//       { to: "/admin/policy", name: "Policy" },
//       { to: "/admin/inactive-employee", name: "Inactive Employee" },
//       { to: "/admin/admin-settings", name: "Settings" },
//     ],

//      E: [
//       { to: "/Employee/dashboard", name: "Employee Dashboard" },
//       { to: "/Employee/performance", name: "Perfomance" },
//       { to: "/Employee/salary-slip", name: "Salary Slip" },
//       { to: "/Employee/expense-tracking", name: "Expense Tracking" },
//       { to: "/Employee/profile", name: "Profile" },
//       { to: "/Employee/attendance-management", name: "Attendance Management" },
//       { to: "/Employee/expense-management", name: "Expense Management" },
//       { to: "/Employee/add-leave-wfh", name: "Add Leave/WFH" },
//       { to: "/Employee/create-workspace", name: "Create Work Space" },
//       { to: "/Employee/work-dashboard", name: "Work Dashboard" },
//       // { to: "/Employee/blogs", name: "Blogs" },
//       { to: "/Employee/task-overview", name: "Task Overview" },
//       { to: "/Employee/policy", name: "Policy" },
//       { to: "/Employee/EPF", name: "EPF" },
//       { to: "/Employee/setting", name: "Settings" },
//     ],
    
//     H: [
//       { to: "/Hr/HRDashboard", name: "HR Dashboard" },
//       { to: "/Hr/EmployeeManagement", name: "Employee Management" },
//       { to: "/Hr/SalaryManagement", name: "Salary Management" },
//       { to: "/Hr/AttendanceManagement", name: "Attendance Management" },
//       { to: "/Hr/OfficeInventory", name: "Office Inventory" },
//       { to: "/Hr/LeaveManagement", name: "Leave Management" },
//       { to: "/Hr/LeaveApproval", name: "Leave Approval" },
//       { to: "/Hr/AddLeaveWFH", name: "Add Leave/WFH" },
//       { to: "/Hr/ExpenseManagement", name: "Expense Management" },
//       { to: "/Hr/PayrollManagement", name: "Payroll Management" },
//       { to: "/Hr/ExpensePayroll", name: "Expense Payroll" },
//       { to: "/Hr/GenerateArrear", name: "Arrear" },
//       { to: "/Hr/AccountLedger", name: "Account Ledger" },
//       { to: "/Hr/policy", name: "Policy" },
//       { to: "/Hr/inactive-employee", name: "Inactive Employee" },
//       { to: "/Hr/Hr-settings", name: "Settings" },
//     ],    
//     S: [{ to: "/Superadmin/dashboard", name: "Settings" }],
//   };

//   const links = [...(roleLinks[userType] || [])];
//   const fetchAccessData = async () => {
//     try {
//       const response = await fetch(
//         `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/GetAccessManagementSuperAdmin`,
//         {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({ firmid: user.firm_id, empid: user.userid }),
//         }
//       );
//       const data = await response.json();
//       if (data.status === "0") {
//         setAccessData(data.data);
//       }
//     } catch (err) {
//       console.error("Error fetching access data (SuperAdmin):", err);
//     }
//   };
//   const fetchAccessDataEmployee = async () => {
//     try {
//       const response = await fetch(
//         `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetAccessManagementAdmin`,
//         {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({ firmid: user.firm_id, empid: user.userid }),
//         }
//       );
//       const data = await response.json();
//       if (data.status === "0") {
//         setAccessemployeData(data.data);
//       }
//     } catch (err) {
//       console.error("Error fetching access data (Employee):", err);
//     }
//   };
//   useEffect(() => {
//     if (user?.firm_id && user?.userid) {
//       setIsLoading(true);
//       Promise.all([fetchAccessData(), fetchAccessDataEmployee()]).finally(() =>
//         setIsLoading(false)
//       );
//     }
//   }, [user]);
//   const hasAccess = (moduleName, roleName) => {
//     if (!accessData) return true;
  
//     const normalizedModuleName = moduleName.trim().toLowerCase();
//     const normalizedRoleName = roleName.trim().toLowerCase();
  
//     const moduleAccess = accessData.find(
//       (module) => module.module_name.trim().toLowerCase() === normalizedModuleName
//     );
  
//     if (!moduleAccess) return true;
  
//     let roleAccess = moduleAccess.data.find(
//       (role) => role.role_name.trim().toLowerCase() === normalizedRoleName
//     );
  
//     if (!roleAccess && roleNameMap[moduleName.trim()]) {
//       const mappedRoleName = roleNameMap[moduleName.trim()].toLowerCase();
//       roleAccess = moduleAccess.data.find(
//         (role) => role.role_name.trim().toLowerCase() === mappedRoleName
//       );
//     }
  
//     if (!roleAccess) return true;
  
//     return roleAccess.access === "Y";
//   };
  
//   return (
//     <div
//       style={{
//         width: "220px",
//         minHeight: "calc(100vh - 56px)",
//         backgroundColor: "#212529",
//         color: "white",
//       }}
//     >
//     <ul className="list-unstyled p-3 mt-3 mb-0">
//   <h5 className="mx-2">
//     {user?.us_type === "A"
//       ? "Admin System"
//       : user?.us_type === "H"
//       ? "HR System"
//       : "Employee System"}
//   </h5>
//   <hr className="m-1" />
//   {links.map((link) => {
//     const access = hasAccess(link.name, link.name);

//     return (
//       <li
//         key={link.to}
//         className={`p-2 d-flex align-items-center ${
//           pathname === link.to ? "bg-light text-dark" : ""
//         }`}
//         style={{ opacity: access ? 1 : 0.5, pointerEvents: access ? "auto" : "none" }}
//         title={access ? "" : "Access Denied"}
//       >
//         <Link
//           to={access ? link.to : "#"}
//           className="text-decoration-none d-flex align-items-center w-100"
//           style={{
//             color: pathname === link.to ? "#000" : "#fff",
//             fontSize: ".8rem",
//             fontWeight: "200",
//             cursor: access ? "pointer" : "not-allowed",
//           }}
//         >
//           <span className="me-2" style={{ fontSize: ".9rem" }}>
//             {iconMap[link.name] || <FaFileAlt />}
//           </span>
//           {link.name}
//         </Link>
//       </li>
//     );
//   })}
// </ul>

//     </div>
//   );
// };

// export default Sidebar;
import React, { useContext } from "react";
import { GlobalContext } from "../Context/GlobalState";

import AdminSidebar from "./AdminSidebar";
import HrSidebar from "./HrSidebar";
import EmployeeSidebar from "./EmployeeSidebar";
import SuperAdminSidebar from "./SuperAdminSidebar";

const Sidebar = () => {
  const { user } = useContext(GlobalContext);
  const userType = user?.us_type || JSON.parse(sessionStorage.getItem("user"))?.us_type || "G";

  switch (userType) {
    case "A":
      return <AdminSidebar />;
    case "H":
      return <HrSidebar />;
    case "E":
      return <EmployeeSidebar />;
    case "S":
      return <SuperAdminSidebar />;
    default:
      return <div>No Sidebar for this user type</div>;
  }
};

export default Sidebar;
